import { $enum } from 'ts-enum-util'
import { IShipperApplicationContact, IShipperApplicationContactRoles } from 'types/graphqlTypes'
import * as yup from 'yup'

const VALID_EMAIL_MESSAGE = 'Please provide a valid email.'
const VALID_ROLE_MESSAGE = 'Please select a Role'

const ContactSchema = yup.object({
  id: yup.string(),
  role: yup
    .mixed<IShipperApplicationContactRoles>()
    .oneOf($enum(IShipperApplicationContactRoles).getValues(), VALID_ROLE_MESSAGE)
    .required(VALID_ROLE_MESSAGE),
  name: yup.mixed<IShipperApplicationContact['name']>(),
  email: yup.string().email(VALID_EMAIL_MESSAGE).nullable(),
  secondaryEmail: yup.string().email(VALID_EMAIL_MESSAGE).nullable(),
  phone: yup
    .mixed<IShipperApplicationContact['phone']>()
    .nullable()
    .test(
      'phone-is-valid',
      'Please provide a valid phone number',
      value => !value || value?.length === 10
    ),
  phoneExtension: yup.mixed<IShipperApplicationContact['phoneExtension']>().nullable(),
  notes: yup.mixed<IShipperApplicationContact['notes']>(),
})

export const ShipperContactsModalSchema = yup.object({
  contacts: yup.array().of(ContactSchema),
})

export type TShipperContactsModalSchema = yup.InferType<typeof ShipperContactsModalSchema>
